export default __webpack_public_path__ + "assets/images/869c76bea9d9beb1ea879b14ec61dc9b.svg";